import React from 'react';

import { NavigationTrackerLink } from '../../ReactComponents/NavigationTracker/NavigationTrackerLink';
import { ActionHeroViewModel } from './ActionHeroViewModel.csharp';

export const ActionHero = ({
    heading,
    headingRed,
    additionalHighlightedText,
    additionalText,
    buttonLabel,
    buttonIcon,
    buttonLink,
    openInNewTab,
    trackNavigation
}: ActionHeroViewModel) => {
    return (
        <>
            {(heading || buttonLabel) && (
                <div className="ActionHero">
                    {heading && <h1 className={headingRed ? 'ActionHero__Heading--Red' : 'ActionHero__Heading--Normal'}>{heading}</h1>}
                    {additionalHighlightedText && <span className="ActionHero__AdditionalHighlightedText">{additionalHighlightedText}</span>}
                    {additionalText && <span className="ActionHero__AdditionalText" dangerouslySetInnerHTML={{ __html: additionalText }} />}
                    {buttonLabel && buttonLink && (
                        <NavigationTrackerLink
                            className="Button Button--Large Button--Primary ActionHero__Button"
                            href={buttonLink}
                            target={openInNewTab ? '_blank' : '_self'}
                            source="ActionHero"
                            disableTracking={!trackNavigation}
                        >
                            <span className="ActionHero__ButtonIcon">
                                <div className={`SvgIcon SvgIcon--${buttonIcon}`}></div>
                            </span>
                            {buttonLabel}
                        </NavigationTrackerLink>
                    )}
                </div>
            )}
        </>
    );
};
